import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';

import { withFormikField } from 'utils/formik';

import { Spacer, Flexer, Checkbox } from '@ontruck/orc';

import {
  StyledFirstColumn,
  StyledExtraContainer,
  StyledExtrasHeader,
  StyledExtrasGroup,
} from './styled';

const t = {
  concept: 'Concept',
  label: 'Manual billing',
};

const ManualBilling = ({ intl, field, form }) => {
  const { name, value } = field;
  const { setFieldValue } = form;

  return (
    <StyledExtrasGroup>
      <StyledExtrasHeader>
        <StyledFirstColumn p="XS" pLeft="S" pRight="S">
          {t.concept}
        </StyledFirstColumn>
      </StyledExtrasHeader>
      <StyledExtraContainer mBottom="M">
        <Flexer.Parent alignItems="center">
          <StyledFirstColumn p="S">
            <Spacer>
              <Checkbox
                checked={!!value}
                label={t.label}
                onChange={(e, { value }) => {
                  setFieldValue(name, value);
                }}
              />
            </Spacer>
          </StyledFirstColumn>
        </Flexer.Parent>
      </StyledExtraContainer>
    </StyledExtrasGroup>
  );
};

ManualBilling.propTypes = {
  intl: PropTypes.object,
  form: PropTypes.object,
  field: PropTypes.object,
};

export default injectIntl(withFormikField(ManualBilling));
